var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_interface_reset",
    width: 19.704,
    height: 24.999,
    viewBox: "0 0 19.704 24.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "restart_alt_FILL0_wght400_GRAD0_opsz48",
    d: "M16.945,29.9a9.122,9.122,0,0,1-6.363-3.412A10.983,10.983,0,0,1,8,19.19a11.273,11.273,0,0,1,1.091-4.9,9.805,9.805,0,0,1,3.059-3.75l1.322,1.453A7.483,7.483,0,0,0,10.8,15.052a9.273,9.273,0,0,0-.953,4.138,8.912,8.912,0,0,0,2.029,5.844,7.559,7.559,0,0,0,5.072,2.838Zm1.844,0V27.872a7.624,7.624,0,0,0,5.072-2.855,8.931,8.931,0,0,0,2-5.828,8.925,8.925,0,0,0-2.321-6.233,7.378,7.378,0,0,0-5.671-2.551h-.615L19.1,12.434l-1.322,1.453L13.687,9.393,17.775,4.9,19.1,6.353,17.253,8.38h.615a9.058,9.058,0,0,1,6.978,3.159A11,11,0,0,1,27.7,19.19a11.024,11.024,0,0,1-2.567,7.3A9.07,9.07,0,0,1,18.79,29.9Z",
    transform: "translate(-8 -4.9)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset-icon.583188be1679f9c94145eb43a1348100.svg";
export { ForwardRef as ReactComponent };